export default [
  {
    path: "/oauth/callback",
    name: "AuthCallback",
    component: () => import("@/views/oauth/AuthCallback.vue"),
  },
  {
    path: "/oauth/loginFail",
    name: "LoginFail",
    component: () => import("@/views/oauth/LoginFail.vue"),
  },
  {
    path: "/logout-success",
    name: "LogoutSuccess",
    component: () => import("@/views/oauth/LogoutSuccess.vue"),
  },
  {
    path: "/relogin",
    name: "ReLogin",
    component: () => import("@/views/oauth/ReLogin.vue"),
  },
];
